export const STYLES_VARIABLES = {
  GRAY_01: '#f8f9fa',
  GRAY_02: '#f1f3f5',
  GRAY_03: '#e9ecef',
  GRAY_04: '#dee2e6',
  GRAY_05: '#ced4da',
  GRAY_06: '#adb5bd',
  GRAY_07: '#868e96',
  GRAY_08: '#495057',
  GRAY_09: '#343a40',
  GRAY_10: '#212529',
  PURPLE_01: '#7966ff',
  PURPLE_02: '#e4e0ff',
  PURPLE_03: '#f1efff',
  PURPLE_04: '#f9fafe',
  PURPLE_05: '#f2f5fc',
  RED_01: '#ef5350',
  RED_02: '#ff7e6e',
  YELLOW: '#f6ae31',
  GREEN_01: '#1a8263',
  GREEN_02: '#00CE91',
  BLUE: '#5095ef',
  WHITE: '#ffffff',
  BLACK: '#000000',
};
